/**
 * Instância Axios dedicada ao painel de administração da plataforma.
 * Usa o token de system-admin (localStorage: 'system-token') em vez do token de tenant.
 */
import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { config } from '@/config/env.config';
import { attachAxiosSentryHandlers } from '@/observability/sentry.axios';

const systemApi = axios.create({
  baseURL: config.api.baseUrl,
  headers: { 'Content-Type': 'application/json' },
});

systemApi.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('system-token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

systemApi.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const status = error.response?.status;
    const cfg = error.config as InternalAxiosRequestConfig;
    const skipRedirect = cfg?.skipAuthRedirect;

    if (status === 401 && !skipRedirect) {
      localStorage.removeItem('system-token');
      localStorage.removeItem('system-auth-storage');
      window.location.href = '/system-login';
    }
    return Promise.reject(error);
  },
);

attachAxiosSentryHandlers(systemApi);

export default systemApi;
